import _JSXStyle from "styled-jsx/style";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';

var Callout = function Callout(_ref) {
  var className = _ref.className,
      color = _ref.color,
      background = _ref.background,
      placement = _ref.placement,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "color", "background", "placement", "children"]);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: "jsx-4171746365" + " " + (props && props.className != null && props.className || "callout text-".concat(color, " m").concat(placement[0], "-5 ").concat(className))
  }), /*#__PURE__*/React.createElement("span", {
    className: "jsx-4171746365" + " " + "callout-arrow arrow  bg-".concat(background, " ").concat(placement)
  }), /*#__PURE__*/React.createElement("div", {
    className: "jsx-4171746365" + " " + "body bg-".concat(background, " text-dark p-3")
  }, children)), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "4171746365"
  }, ".callout.jsx-4171746365{border:2px solid currentColor;position:relative;}.callout.jsx-4171746365 .body.jsx-4171746365{position:relative;}.callout.jsx-4171746365 .arrow.jsx-4171746365{border:2px solid currentColor;display:block;height:40px;position:absolute;width:40px;-webkit-transform:translate(-20px,-20px) rotate(45deg);-ms-transform:translate(-20px,-20px) rotate(45deg);transform:translate(-20px,-20px) rotate(45deg);}.callout.jsx-4171746365 .top.jsx-4171746365{left:50%;top:0%;}.callout.jsx-4171746365 .right.jsx-4171746365{left:100%;top:50%;}.callout.jsx-4171746365 .bottom.jsx-4171746365{border-top-color:transparent;border-left-color:transparent;left:50%;top:100%;}.callout.jsx-4171746365 .left.jsx-4171746365{left:0%;top:50%;}"));
};

Callout.displayName = 'Callout';
Callout.defaultProps = {
  className: '',
  color: 'primary',
  background: 'light',
  placement: 'bottom'
};
export default Callout;